import React from 'react';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { afterItems, beforeItems, transformationStats } from '../data/curriculum';
export function TransformationSection() {
  return <section className="bg-brand-main px-4 py-20 md:py-28" data-id="element-170" data-mp="2ww2non90qrti">
      <Reveal className="mx-auto max-w-5xl" data-id="element-171" data-mp="2rz2h8b89bn1v">
        <div className="mx-auto max-w-3xl text-center" data-id="element-172" data-mp="2ryaxbxo0vdrf">
          <p className="mb-4 text-xs font-extrabold tracking-[0.18em] text-brand-green" data-id="element-173" data-mp="2nxh6avfa9iub">UNA CARTA PARA TI</p>
          <h2 className="text-4xl font-black leading-[1.08] tracking-tight text-brand-deep md:text-5xl" data-id="element-174" data-mp="2j5zb6nzxych9">
            De una profe de Biología agotada a una{' '}
            <span className="italic text-brand-green" data-id="element-175" data-mp="2982z9tz6jdi3">guía de Ciencias segura y confiada</span>
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-brand-gray md:text-base" data-id="element-176" data-mp="248qdlck1och3">
            Preparar clases no debería costarte tus noches y tus fines de semana. Por eso creamos Biología Lista: teoría
            clara, actividades y evaluaciones que te devuelven el tiempo… sin resignar la calidad de tus clases.
          </p>
        </div>

        <div className="mx-auto my-12 grid max-w-3xl divide-y divide-brand-dark overflow-hidden rounded-2xl border border-brand-dark bg-brand-alt shadow-sm sm:grid-cols-3 sm:divide-x sm:divide-y-0" data-id="element-177" data-mp="k33sgjaip3zg">
          {transformationStats.map(({
          value,
          label
        }) => <div key={label} className="px-5 py-5 text-center" data-id="element-178" data-mp="y1af13a0nhjt">
              <strong className="block font-serif text-3xl leading-none text-brand-amber" data-id="element-179" data-mp="130n29p4suqmx">{value}</strong>
              <span className="mt-2 block text-[10px] font-extrabold leading-tight tracking-[0.08em] text-brand-gray" data-id="element-180" data-mp="p15m1y5kklp6">
                {label}
              </span>
            </div>)}
        </div>

        <div className="overflow-hidden rounded-3xl border border-brand-dark bg-brand-alt shadow-[0_18px_45px_rgba(20,80,58,0.10)]" data-id="element-181" data-mp="39rcvl3daedno">
          <div className="grid md:grid-cols-2" data-id="element-182" data-mp="3dthilj98cc1c">
            <Comparison title="ANTES" items={beforeItems} positive={false} data-id="element-183" data-mp="1k9zesbe55jo1" />
            <Comparison title="CON BIOLOGÍA LISTA" items={afterItems} positive data-id="element-184" data-mp="1kc238qznb4qn" />
          </div>
          <div className="border-t border-brand-dark bg-brand-main px-6 py-4 text-center text-xs font-semibold text-brand-gray" data-id="element-185" data-mp="1fbo2zv4acz36">
            Enseñar Biología bien debería ser simple.
          </div>
        </div>
      </Reveal>
    </section>;
}
function Comparison({
  title,
  items,
  positive
}: {
  title: string;
  items: string[];
  positive: boolean;
}) {
  const Icon = positive ? CheckCircle2Icon : XCircleIcon;
  return <div className={`flex flex-col p-6 md:p-9 ${positive ? 'border-t border-brand-dark bg-brand-alt md:border-l md:border-t-0' : 'bg-[#F5F4F0]'}`} data-id="element-186" data-mp="wmr7xp12e2jw">
      <div className="mb-7 flex items-start justify-between gap-4" data-id="element-187" data-mp="mns028o4iaxy">
        <div data-id="element-188" data-mp="2lzl0yge180fy">
          <p className={`text-[10px] font-extrabold tracking-[0.16em] ${positive ? 'text-brand-green' : 'text-brand-gray'}`} data-id="element-189" data-mp="2ly9ycjwboyqf">
            {positive ? 'EL SISTEMA LISTO PARA ENSEÑAR' : 'EL COSTO DE EMPEZAR DE CERO'}
          </p>
          <h3 className="mt-2 font-serif text-2xl font-bold tracking-tight text-brand-deep" data-id="element-190" data-mp="2pffqf7vhayma">{title}</h3>
        </div>
        <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full ${positive ? 'bg-brand-green text-white shadow-md' : 'bg-brand-alt text-[#C24141]'}`} data-id="element-191" data-mp="2y9u8tjbb2p9m">
          <Icon className="h-5 w-5" aria-hidden="true" data-id="element-192" data-mp="26io38nctfzcy" />
        </div>
      </div>
      <ul className="space-y-2.5" data-id="element-193" data-mp="26kr2lxzuz4uc">
        {items.map(item => <li key={item} className={`flex items-center gap-3 rounded-xl px-3 py-3 ${positive ? 'bg-brand-main' : 'bg-brand-alt/70'}`} data-id="element-194" data-mp="2akhygg48sb5q">
            <Icon className={`h-4 w-4 shrink-0 ${positive ? 'text-brand-green' : 'text-[#C24141]'}`} aria-hidden="true" data-id="element-195" data-mp="2kiflj0ad81wr" />
            <span className={`text-sm leading-snug ${positive ? 'font-semibold text-brand-text' : 'text-brand-gray'}`} data-id="element-196" data-mp="3vxce2k5rd98v">
              {item}
            </span>
          </li>)}
      </ul>
    </div>;
}